import React, { useEffect, useRef, useState } from 'react';
import {
  NavbarComponent,
  NavigationMenuComponent,
} from '../../organisms/organisms.index';
import './WishFinder.component.scss';
import WishFinderFormComponent from './WishFinderForm.component';
import { findWishesByText } from '../../../store/wishlist/wishlist.actions';
import { IWishFind } from '../../../domain/wish.interface';
import { FormattedMessage } from 'react-intl';
import InfiniteScroll from 'react-infinite-scroller';
import ShareWishModalComponent from '../../organisms/share-wish-modal/ShareWishModal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ERoutes } from '../../../assets/constants/routes';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { WishCardComponent } from '../../atoms/atoms.index';

export function WishFinderComponent(props: any) {
  const pageSize = 5;
  const scrollRef = useRef<any>();
  const [searchText, setSearchText] = useState<string>();
  const [wish, setWish] = useState<IWishFind>();
  const [wishes, setWishes] = useState<IWishFind[]>([]);
  const [wishesList, setWishesList] = useState<IWishFind[]>([]);

  useEffect(() => {
    findWishes().then();
  }, []);

  const handleOnSubmit = async (values: any) => {
    const { text = '' } = values;
    return text.trim() !== searchText && (await findWishes(text));
  };

  const findWishes = async (text: string = '') => {
    const list: IWishFind[] = await findWishesByText(text);
    setWishes(list);
    scrollRef.current.pageLoaded = 0;
    setWishesList([]);
    setSearchText(text);
  };

  const loadMore = (page: number) => {
    setWishesList(wishes.slice(0, page * pageSize));
  };

  const shareItem = (id: string) => {
    setWish(wishes.find(it => +it.id === +id));
  };

  const accessToContactWishList = (item: IWishFind) => {
    const { contact } = item;
    if (contact) {
      props.history.push({
        pathname: ERoutes.CONTACT_WISH_LIST_CATALOGUE,
        state: { contact, readOnly: true },
      });
    }
  };

  const handleShareModalClose = () => setWish(undefined);

  return (
    <div className='wish-finder-container fluid-container page-container'>
      <NavbarComponent hideSearch={true} />
      <NavigationMenuComponent {...props} />
      <div className='content-wrapper'>
        <div className='title-container pb-3'>
          <h4 className='subtitle'>
            <FormattedMessage id='wish-finder.title' />
          </h4>
        </div>

        <WishFinderFormComponent onSubmit={handleOnSubmit} />

        {!searchText && (
          <div className='intro'>
            <FormattedMessage id='wish-finder.intro' />
          </div>
        )}

        <div className='fluid-container mt-4'>
          <InfiniteScroll
            ref={scroll => {
              scrollRef.current = scroll;
            }}
            pageStart={0}
            loadMore={loadMore}
            threshold={pageSize}
            useWindow={true}
            hasMore={wishes.length > wishesList.length}
          >
            {wishesList &&
              wishesList.map((it: IWishFind) => (
                <div className='wish-card-wrapper mb-3'>
                  <div className='username'>
                    {it.private ? (
                      <FontAwesomeIcon icon='user-lock' />
                    ) : it.contact ? (
                      <WishFinderContactUsername
                        wish={it}
                        onClick={accessToContactWishList}
                      />
                    ) : (
                      <WishFinderUsername {...it} />
                    )}
                  </div>
                  <WishCardComponent
                    key={it.id}
                    wish={it}
                    shareItem={shareItem}
                  />
                </div>
              ))}
          </InfiniteScroll>
        </div>
      </div>
      <ShareWishModalComponent
        wishId={wish ? wish.id : ''}
        wishListId={wish ? wish.wishListId : ''}
        showModal={!!wish}
        handleClose={handleShareModalClose}
      />
    </div>
  );
}

const WishFinderUsername = (props: IWishFind) => {
  const { contact, nickname } = props;
  return (
    <div>
      <FontAwesomeIcon icon={contact ? 'user-friends' : 'user'} />
      <span>{contact ? contact.alias : nickname}</span>
    </div>
  );
};

const WishFinderContactUsername = (props: {
  wish: IWishFind;
  onClick: (wish: IWishFind) => void;
}) => {
  const { wish, onClick } = props;
  const { contact, nickname } = wish;
  const contactName = contact
    ? contact.user.name || contact.user.nickname
    : nickname;

  return (
    <OverlayTrigger
      placement='top'
      overlay={<Tooltip id='button-tooltip'>{contactName}</Tooltip>}
    >
      <div className='pointer' onClick={() => onClick(wish)}>
        <WishFinderUsername {...wish} />
      </div>
    </OverlayTrigger>
  );
};
